import React, { useState, useEffect } from "react";
import "../../../../src/styles/organization.css";
import { Modal } from "@appkit4/react-components/modal";
import ModalFooter from "@appkit4/react-components/esm/modal/ModalFooter";
import * as Yup from "yup";
import displayToastMessage from "../../../../src/components/Common/Alert/displayToastMessage";
import PropTypes from "prop-types";
import APIService from "../../../services/apiAxiosService.js";
import useHttp from "../../../hooks/useHttp.js";
import { Table, Column } from "@appkit4/react-components/table";
import { Input } from "@appkit4/react-components/field";
import { Pagination } from "@appkit4/react-components/pagination";
import { Checkbox } from "@appkit4/react-components";
import { Select } from "@appkit4/react-components/select";

export default function ViewQuestionnaire(props) {
  const formValues = {
    questiontype: "",
    question: "",
  };
  const [questionCount, setQuestionCount] = useState([]);
  const [selectedOrg, setSelectedOrg] = useState("");
  const [errorOrgMessage, setErrorOrgMessage] = useState("");
  const [isErrorMessageShown, setIsErrorMessageShown] = useState(false);
  const [visible, setVisible] = useState(false);
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [checkValue, setCheckValue] = useState(false);
  const [originalData, setOriginalData] = useState([]);
  const [selectedIndexs, setSelectedIndexs] = useState([]);
  const [button, setButton] = useState(false);
  const [loading, setLoading] = useState(false);
  const [orgDetails, setOrgDetails] = useState();
  const [editMode, setEditMode] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [indicator, setIndicator] = useState(false);
  const [initialValues, setInitialValues] = useState(formValues);
  const [tableData, setTableData] = useState([]);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState([]);
  const [current, setCurrent] = useState(1);
  const [totalPage, setTotalPage] = useState(500);
  const { sendRequest: addNewOrganization } = useHttp();
  const { sendRequest: editQuestion } = useHttp();
  const { sendRequest: deleteQuestionnaire } = useHttp();
  const { sendRequest: addOrganization } = useHttp();
  const [initialId, setInitialID] = useState([]);
  let { allOrganizations, reloadData, SetTab } = props;
  const [length, setLength] = useState(0);
  const [vendorQuestionCount, setVendorQuestionCount] = useState(0);
  const [vendorQuestionQues, setVendorQuestionQues] = useState([]);
  const handleCancel = (e) => {
    setDeleteVisible(false);
    setVisible(false);
  };
  const { sendRequest: handleQuestionnaireCount } = useHttp();
  const { sendRequest: handleOrgnizationVendor } = useHttp();
  useEffect(() => {
    if (selectedIndexs.length === originalData.length) setCheckValue(true);
    else setCheckValue(false);
  }, [selectedIndexs]);
  const [questiontype, setQuestiontype] = useState();
  const [question, setQuestion] = useState();
  const getQuestionCount = (e) => {
    const payload = e ? e : 0;
    try {
      handleQuestionnaireCount(
        APIService.questionCount(payload),
        payload == 0 ? responseHandlerQuestionnaireCount : responseHandlerQuestionnaireData
      );
    } catch (error) {
      console.log("Error", error);
      setLoading(false);
      let Msg = "Please create new questionnaire!";
      displayToastMessage(Msg, "error");
    }
  };

  const getOrganizationVendor = (e) => {
    try {
      handleOrgnizationVendor(
        APIService.handleOrgnizationVendor(e),
        responseHandlerQuestions
      );
    } catch (error) {
      console.log("Error", error);
      setLoading(false);
      let Msg = "Please create new questionnaire!";
      displayToastMessage(Msg, "error");
    }
  }
  const selectOrginisation = async (e) => {
    setSelectedOrg(e);
    setErrorOrgMessage("")
    getQuestionCount(e);
    getOrganizationVendor(e);

    if(vendorQuestionCount==0){
      setButton(true);
    }
  };

  useEffect(() => {
    //  getQuestionCount();

    setTableData(allOrganizations);
    setFilter(allOrganizations);
    setOriginalData(allOrganizations);
    let totalPageLength = Math.ceil(allOrganizations.length / 10);
    if (totalPageLength === 0) {
      totalPageLength = 1;
    }
    setTotalPage(totalPageLength);

    var arr = [];
    var arr1 = [];

    const countData = questionCount.forEach((val, i) => {
      arr.push(val.quesid);
      arr1.push(val.quesid);
    });



    setInitialID(arr1);

    setSelectedIndexs(arr);
  }, [allOrganizations]);

  useEffect(() => {
    const result = tableData?.filter((organizationList) => {
      return organizationList.question
        .toLowerCase()
        .match(search.toLocaleLowerCase());
    });
    setFilter(result);
    let totalPageLength = Math.ceil(result.length / 10);
    if (totalPageLength === 0) {
      totalPageLength = 1;
    }
    setTotalPage(totalPageLength);
  }, [search]);

  let validationSchema = Yup.object().shape({
    question: Yup.string().required("Question is Required"),
  });

  const handleSubmitData = async (values, { resetForm }) => {
    setLoading(true);

    let data = {
      question: values.question,
      questiontype: values.questiontype,
      vendorquestionid: values.vendorquestionid,
      checkBox: dataFromChild
    };
    editQuestion(
      APIService.editQuestion(data),
      responseHandlerEdit,
      errorHandlerEdit
    );
  };

  const responseHandlerEdit = (result) => {
    setVisible(false);
    setLoading(false);
    setSearch("");
    displayToastMessage(result.MSG, "success");
    SetTab(3);
    handelEditScreen();
  };

  const errorHandlerEdit = () => {
    setIndicator(false);
    setVisible(false);
    setSearch("");
    displayToastMessage("Something went wrong!", "error");
  };

  const getOrgDetails = async (Id) => {
    const filteredData = allOrganizations.filter(
      (item) => item.vendorquestionid == Id
    );
    setOrgDetails(filteredData[0]);
  };

  useEffect(() => {
    const formValuesClone = { ...initialValues };
    // if orgDetails are updated, then update the initial values
    formValuesClone.questiontype = orgDetails ? orgDetails.questiontype : "";
    formValuesClone.question = orgDetails ? orgDetails.question : "";
    formValuesClone.dropdownvalue = orgDetails ? orgDetails.dropdownvalue : "";

    setInitialValues(formValuesClone);
  }, [orgDetails]);

  const handelEditScreen = () => {
    setTableData(allOrganizations);
    setFilter(allOrganizations);
    let totalPageLength = Math.ceil((allOrganizations?.length) / 10);
    if (totalPageLength === 0) {
      totalPageLength = 1;
    }
    setTotalPage(totalPageLength);
    window.location.reload();
    SetTab(3);

  };

  const responseHandlerDelete = (result) => {
    if (result.CODE) {
      setDeleteVisible(false);
      setLoading(false);
      setSearch("");
      displayToastMessage("Questionnaire deleted successfully!", "success");
      SetTab(3);
      handelEditScreen();

    }
  };

  const errorHandlerDelete = () => {
    displayToastMessage("Something went wrong!", "error");
    setSearch("");
  };

  const handleDelete = async (value) => {
    setIndicator(true);
    let data = {
      ID: value,
      org: Number(sessionStorage.getItem("orgId")),
    };

    deleteQuestionnaire(
      APIService.deleteQuestionnaire(data),
      responseHandlerDelete,
      errorHandlerDelete
    );
  };

  if (indicator) {
    return (
      <div className="a-loading a-primary a-m-10 a-loading-24 spinner-alignment"></div>
    );
  }

  const renderActionCell = (row) => {
    return (
      <>
        <span
          className="Appkit4-icon icon-edit-fill action-icon pointer"
          title="Edit Organization"
          onClick={() => handleEditButton(row)}
        ></span>{" "}
        &nbsp;
        <span
          className=" Appkit4-icon icon-delete-fill action-icon pointer"
          title="Delete Organization"
          onClick={() => handleDeleteButton(row)}
        ></span>
      </>
    );
  };

  const handleEditButton = (row) => {
    setEditMode(true);
    setVisible(true);
     setQuestiontype(row?.questiontype);
     setSelectedId(row);
     setQuestion(row?.question);
  };

  const handleDeleteButton = (row) => {
    setDeleteVisible(true);
    setEditMode(true);
    setSelectedId(row?.vendorquestionid);
  };

  
  



  const responseHandlerQuestionnaireCount = (data) => {
    if (data.MSG) {
      setQuestionCount(data.MSG);
      setLength(Object.keys(data?.MSG).length);

    }
  };

  const responseHandlerQuestions = (data) => {

    if (data.MSG) {
      setVendorQuestionCount(data.MSG[0].count);
    }
  };

  const responseHandlerQuestionnaireData = (data) => {
    if (data.MSG) {
      const ques = data.MSG.map((val, i) => {
        return val?.quesid
      })
      setSelectedIndexs(ques);

      const ques1 = data.MSG.map((val, i) => {
        return val?.quesid
      })
      setVendorQuestionQues(ques1);

      setQuestionCount(data.MSG);
      setLength(Object.keys(data?.MSG).length);

      if (Object.keys(data?.MSG).length >= 10) {

        displayToastMessage("Can not add more than 10 value", "error");
        setButton(false);
      }
    }
  };
  const renderOrderCell = (row, field) => {
    const onCheckboxChange = (value) => {

      if (((event.target).parentNode)
        .className.indexOf('ap-checkbox-label') > -1) {
        return;
      }
      setCheckValue(value => !value)

      if (value && selectedOrg) {
        selectedIndexs.push(row.vendorquestionid);
        setButton(true);
        setSelectedIndexs([...selectedIndexs]);

      } else {
        selectedIndexs.splice(
          selectedIndexs.indexOf(row.vendorquestionid),
          1
        );
        setSelectedIndexs([...selectedIndexs]);

      }

    };

    if (!(field in row)) return "";

    return (
      <Checkbox
        value={row[field]}
        checked={selectedIndexs.includes(row.vendorquestionid)}
        onChange={(value) => onCheckboxChange(value)}
      // disabled={selectedIndexs.includes(row.vendorquestionid)?true:false}
      >
        <span>{row[field]}</span>
      </Checkbox>
    );
  };

  const handleSelect = () => {
    if (vendorQuestionCount > 1) {
      displayToastMessage('Third party already created', "error");

    }
    else if (length <= 10) {
      const org = selectedOrg;
      const id = selectedIndexs;
      const user = sessionStorage.getItem("userId");

      var final = selectedIndexs.filter(function (item) {
        return !vendorQuestionQues.includes(item);
      });


      addOrganization(
        APIService.addOrganizationQuestion(final, org, user),
        responseHandler,
        errorHandlerEdit
      );
    } else {
      displayToastMessage('Can not add more than 10 question', "error");

    }
  };

  const responseHandler = (result) => {
    setButton(false);
    displayToastMessage('Questionnaire added with organization successfully', "success");
    reloadData();
    SetTab(0);
    // setTimeout(() => {
    //   props.history.push("/masterRepository");
    // }, 2000);

    setSelectedOrg("");
  };

  var qus = [
    {
      id: "1",
      name: "select",
    },
    {
      id: "2",
      name: "text",
    },
  ];

  return (
    <div className="App">
      <div className="col-lg-12 mt-3 pl-1">

        <div className="row">
          <div className="col-sm-6">
            <div className="cv-input-field-container">
              <label htmlFor="Organization" className="cv-input-label">
                Organization<span className="asterisk-required">*</span>
              </label>
              <Select
                dropdownRenderMode="portal"
                value={selectedOrg}
                data={props.allOrganizationsData}
                valueKey="org_id"
                labelKey="org_name"
                placeholder="Select organization"
                showSearchOnToggle={true}
                onSelect={(e) => selectOrginisation(e)}
              >
              </Select>
            </div>
            <div className="cv-input-field">
              <span
                className="form-label errorMsg"
                style={{
                  display: isErrorMessageShown ? "block" : "none",
                }}
              >
                {errorOrgMessage}
              </span>
            </div>
          </div>
        </div>

        <div className="ap-table-demo menu-tableAlignment-width">
          {tableData.length > 0 ? (
            <Input
              type="text"
              title="Search Questionnaire"
              value={search}
              className="ap-field-wrapper-tableSearch"
              onChange={(e) => setSearch(e)}
            />
          ) : (
            ""
          )}

          <Table
            originalData={filter}
            // className="ap-table-checkable"
            selectedIndexs={selectedIndexs}
            hasTitle
            currentPage={current}
            pageSize={10}
            className={filter.length === 0 ? "" : "biaTableBU"}
          >
            <Column
              field="vendorquestionid"
              sortKey="vendorquestionid"
              // sortFunc1={sortFuncForOrder1}
              // sortFunc2={sortFuncForOrder2}
              renderCell={renderOrderCell}
            >Serial No.</Column>
            <Column
              field="questiontype"
              sortKey={filter.length > 0 ? "questiontype" : ""}
              // sortFunc1={sortFuncForOrder1}
              // sortFunc2={sortFuncForOrder2}
            >
              Question Type
            </Column>
            <Column
              field="question"
              sortKey={filter.length > 0 ? "question" : ""}
            >
              Question
            </Column>

            <Column field="vendorquestionid" renderCell={renderActionCell}>
              Action
            </Column>
          </Table>
          {filter.length === 0 ? (
            <div className="noData">No data available in table</div>
          ) : (
            ""
          )}
          <Pagination
            defaultCurrent={1}
            current={current}
            total={totalPage}
            onPageChange={(page) => setCurrent(page)}
          ></Pagination>
        </div>
        {button && vendorQuestionCount==0  &&(
          <button
            type="submit"
            className="save-button mt-2 m-l-2"
            onClick={() => handleSelect()}
          >
            Save
          </button>
        )}
      </div>
      <div>
        <Modal
          className="baseline-modal-showcase"
          visible={visible}
          onCancel={handleCancel}
          title={editMode ? "View Questionnaire" : "Add New Questionnaire"}
          bodyStyle={{ maxHeight: "280px" }}
          footerStyle={{ paddingTop: "8px", marginTop: "-8px" }}
          modalStyle={{ width: "49.75rem", maxHeight: "fit-content" }}
        >
         
 <form>
            <div className="row">
              <div className="col-sm-12">
                <div className="cv-input-field-container">
                  <label htmlFor="OrganizationUsers" className="cv-input-label">Questionnaire</label>
                  <Select
                        className="cv-input-field"
                        dropdownRenderMode="portal"
                        searchable={true}
                        type="text"
                         value={questiontype}
                        data={qus}
                        valueKey="name"
                        labelKey="name"
                        showSearchOnToggle={true}
                        placeholder="Select Questionnaire"
                      
                        name="questiontype"
                        disabled
                      >
                  </Select>
                  
                </div>
              </div>
              
            </div>
            <div className="row">
              <div className="col-sm-12">
              <div className="cv-input-field-container">
                  <label htmlFor="RoleUsers" className="cv-input-label">Question</label>
                  <input
                        className={"cv-input-field pl-2"}
                        type="text"
                        id="ParentOrganizationQuestionnaire"
                        name="question"
                        value={question}
                        disabled
                      />
                </div>
                
              </div>
            </div>
          </form>
        
          <ModalFooter></ModalFooter>
        </Modal>
        <Modal
          className="baseline-modal-showcase"
          visible={deleteVisible}
          onCancel={handleCancel}
          bodyStyle={{ maxHeight: "280px" }}
          footerStyle={{ paddingTop: "8px", marginTop: "-8px" }}
          modalStyle={{ width: "49.75rem", maxHeight: "fit-content" }}
        >
          <div className="modal-title">
            Are you sure you want to delete this entry?
          </div>
          <ModalFooter>
            <button
              type="button"
              className="cancel-button"
              onClick={handleCancel}
            >
              No
            </button>

            <button
              type="submit"
              className="save-button m-l-2"
              onClick={() => handleDelete(selectedId)}
            >
              Yes
            </button>
          </ModalFooter>
        </Modal>
      </div>
    </div>
  );
}

ViewQuestionnaire.propTypes = {
  allOrganizations: PropTypes.any,
};
